"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var vue_3 = require("vue");
var echarts = __importStar(require("echarts"));
var index_1 = require("@/store/index");
exports.default = (0, vue_1.defineComponent)({
    __name: 'DynastyCharts',
    props: {
        countData: {
            type: Array,
            default: function () { return []; }
        },
        category: {
            type: Array,
            default: function () { return []; }
        },
    },
    setup: function (__props) {
        var props = __props;
        var mainStore = (0, index_1.useMainStore)();
        var dark = (0, vue_3.computed)(function () { return mainStore.isDark; });
        (0, vue_3.watch)(dark, function (_, next) {
            initCharts(next);
        });
        var myChart;
        var lineCharts = (0, vue_3.ref)();
        var initCharts = function (isDark) {
            var option;
            var chartsTheme = isDark ? "light" : "dark";
            if (myChart) {
                myChart.dispose();
            }
            myChart = echarts.init(lineCharts.value, chartsTheme);
            // option
            option = {
                title: {
                    text: '朝代文章总量统计（篇）',
                    top: 10,
                    left: 10,
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        return "\n        \u671D\u4EE3\uFF1A".concat(params[0].name, " </br> \n        \u6587\u7AE0\u603B\u91CF\uFF1A").concat(params[0].value, "\u7BC7\n        ");
                    },
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                toolbox: {
                    show: true,
                    orient: 'horizontal',
                    right: '25',
                    top: 'top',
                    feature: {
                        mark: { show: true },
                        // dataView: { show: true, readOnly: false },
                        magicType: { show: true, type: ['line', 'bar'] },
                        // restore: { show: true },
                        saveAsImage: { show: true }
                    }
                },
                xAxis: {
                    data: props.category,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    splitLine: { show: false },
                },
                yAxis: {
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    }
                },
                series: [
                    {
                        name: '文章总量',
                        type: 'bar',
                        barWidth: 10,
                        itemStyle: {
                            borderRadius: 5,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#14c8d4' },
                                { offset: 1, color: '#43eec6' }
                            ])
                        },
                        label: {
                            show: true,
                            position: 'top',
                            formatter: '{c}',
                        },
                        animationDuration: 3000,
                        data: props.countData
                    },
                ]
            };
            option && myChart.setOption(option);
        };
        (0, vue_3.onMounted)(function () {
            initCharts(!mainStore.isDark);
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                ref_key: "lineCharts",
                ref: lineCharts,
                style: { "height": "100%", "width": "100%", "background-color": "white" },
                id: "main"
            }, null, 512));
        };
    }
});
